export const AREA_PAGE_FOURTH_MAP_CARD_FLAG = 'area-page-fourth-map-card';
export const RECENTLY_SOLD_NAV_LINK_FLAG = 'nav-recently-sold-link-update';
export const MAP_SINGLE_LISTING_PREVIEW_FLAG = 'map-single-cluster-experiment';
export const NEW_HEADER_FLAG = 'use-new-navigation-menu';
export const MAINTENANCE_BANNER_FLAG = 'scheduled-maintenance-banner';
export const FEEDBACK_BANNER_FLAG = 'feedback-survey-banner';
export const SOLD_LISTING_PVR_VS_HOME_ESTIMATE_FLAG = 'sold-listing-PVR-vs-home-estimate';
export const AGENT_PROFILE_TRANSLATION_FLAG = 'agent-profile-translation';
export const PROVIDER_DISCLAIMER_TRANSLATION_FLAG = 'provider-disclaimer-translation';
